import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import { appReducer } from './reducers'


const combinedReducers = combineReducers({
	appReducer: appReducer
})

const rootReducer = (
	state,
	action
) => {
	return combinedReducers(state, action)
}

export const store = configureStore({
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({
		immutableCheck: false,
		serializableCheck: false
	}),
	reducer: rootReducer
})
